import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IGroup } from '../../model/group.model';
import { ISibasiHTTPResponse } from '../../model/sibasiHTTPResponse.model';
import { IPagination } from '../../model/util.model';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
  readonly httpClient = inject(HttpClient);

  getAllGroups(): Observable<ISibasiHTTPResponse<IGroup[]>> {
    return this.httpClient.get<ISibasiHTTPResponse<IGroup[]>>(
      `${environment.api_url}userGroups/all`
    );
  }

  getAllGroupsPagination(
    paginationParams: IPagination<IGroup[]>
  ): Observable<ISibasiHTTPResponse<IPagination<IGroup[]>>> {
    return this.httpClient.post<ISibasiHTTPResponse<IPagination<IGroup[]>>>(
      `${environment.api_url}userGroups/groups/paginated`,
      paginationParams
    );
  }

  getGroupById(groupId: string): Observable<ISibasiHTTPResponse<IGroup>> {
    return this.httpClient.get<ISibasiHTTPResponse<IGroup>>(
      `${environment.api_url}userGroups/one/${groupId}`
    );
  }

  deleteGroup(groupId: string): Observable<ISibasiHTTPResponse<IGroup>> {
    return this.httpClient.delete<ISibasiHTTPResponse<IGroup>>(
      `${environment.api_url}userGroups/delete/${groupId}`
    );
  }

  createGroup(group: IGroup): Observable<ISibasiHTTPResponse<IGroup>> {
    return this.httpClient.post<ISibasiHTTPResponse<IGroup>>(
      `${environment.api_url}userGroups/new`,
      group
    );
  }

  updateGroup(group: IGroup): Observable<ISibasiHTTPResponse<IGroup>> {
    return this.httpClient.post<ISibasiHTTPResponse<IGroup>>(
      `${environment.api_url}userGroups/update/${group._id}`,
      group
    );
  }

  removeUserFromGroup(
    userId: string,
    groupId: string
  ): Observable<ISibasiHTTPResponse<IGroup>> {
    return this.httpClient.post<ISibasiHTTPResponse<IGroup>>(
      `${environment.api_url}userGroups/remove/from/group/${groupId}`,
      { user: userId }
    );
  }
}
